import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./reducers/auth-slice";
import ftpSlice from "./reducers/ftp-slice";
import jobSlice from "./reducers/job-slice";
import orderSlice from "./reducers/order-slice";
import uiSlice from "./reducers/ui-slice";

const store = configureStore({
    reducer: {
        ui: uiSlice.reducer,
        auth: authSlice.reducer,
        order: orderSlice.reducer,
        job: jobSlice.reducer,
        ftp: ftpSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;